import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
const tableData = {};
const pageConfig = {
    loading:false,
    tableName:'list-price',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "ITEM":[
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
}
const state = () => ({
    listPrice: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.listPrice.pageConfig,
    getPageConfigTree: state => state.listPrice.pageConfigTree,
    getPageKey:state => state.listPrice.pageKey,
}
const mutations ={
    setLoading(state, data){
        state.listPrice.loading = data;
        if(isNotEmpty(state.listPrice.pageConfig)){
            Object.keys(state.listPrice.pageConfig).forEach((key,index)=>{
                state.listPrice.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.listPrice.pageConfig = data.pageConfig;
        state.listPrice.pageConfigTree = data.allArrData;
        state.listPrice.pageKey = getRandomString();
        if(isNotEmpty(state.listPrice.pageConfig)){
            Object.keys(state.listPrice.pageConfig).forEach((key,index)=>{
                state.listPrice.pageConfig[key].height = state.listPrice.height
            })
        }
    },
    setList(state, data) {
        state.listPrice.pageConfig[data.obj].data = data.data;
        state.listPrice.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.listPrice.height = (data-20) + 'px';
        if(isNotEmpty(state.listPrice.pageConfig)){
            Object.keys(state.listPrice.pageConfig).forEach((key,index)=>{
                state.listPrice.pageConfig[key].height = state.listPrice.height;
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.listPrice.pageConfig,pageConfigTree:state.listPrice.pageConfigTree});
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState,commit }, payload) {
        if(state.listPrice.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__material_price_list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.listPrice.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.listPrice.tableName,top_tools:state.listPrice.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.listPrice.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.listPrice.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__material_price_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
